import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

// ← IMPORT THIS so initializeApp() runs
import './firebase';

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
